export default class {
    constructor({ store }) {
        this._store = store;
    }

    handle() {
        this._store.$marketing.pageEvent('Plagiarism Report Page View').sendToAmplitude();
    }

    handleExample() {
        this._store.$marketing.pageEvent('Plagiarism Example Page View').sendToAmplitude();
    }

    handleAIContentDetectorModalOpened() {
        this._store.$marketing.trackEvent('Plagiarism – AI Content Detector Opened').sendToAmplitude();
    }
    toggleAddParaphraserToPcOrder(props) {
        // eslint-disable-next-line camelcase
        const { value, language, risk_type, total_words } = props;

        this._store.$marketing.trackEvent(`Plagiarism Free Check Paraphaser ${value ? 'Added' : 'Removed'}`, {
            language,
            risk_type,
            total_words,
        }).sendToAmplitude();

        return value;
    }
}
